import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { UserTypeContext } from "../../context/userStatus";
import { TRACKING_EVENT_NAMES, TUTORIAL_STEPS } from "./tutorialsSteps";
import { Box, Dialog, useTheme } from "@mui/material";
import useWidth from "../../utils/useWidth";
import { setToturialStepGlobal, setVisibleTutorialGloabl } from "../../store/actions/userTypeAction";
import SpotlightOverlay from "./Spotlight";
import TableSpotlightOverlay from "./TableSpotlight";
import useStyles from "../trackerNewV2/TrackingClasses";
import CustomTooltip from "./CustomTooltip";
import CustomElementSpotlight from './CustomElementSpotlight';
import LastCelebration, { ImageContent } from "./LastCelebration";
import ConfettiTNT from "../insightsV2/common/confetti";
import MobileLinkModal from "../trackerNewV2/mobileLinkModal";
import { SnackBarCompV2 } from "../../components/snackBar";
import CommonTypo from "../../components/CommonTypo";
import ModalCloseIconBlack from "../../assets/images/icon/modalCloseIconBlack";
import { trackingService } from "../../services/tracking";
import { TrackingContext } from "../../context/userTracking";
import { TRACKING_CONST } from "../trackerNewV2/constants";
import moment from "moment";

const TutorialsFlow = () => {
    const { state: IUserTypeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    const { state: ITrackerState, dispatch: trackingDispatch } =
        useContext(TrackingContext);
    const isDarkMode = useTheme().palette.mode === "dark" || IUserTypeState.isDarkMode
    const {
        calendar,
    } = ITrackerState
    const [showSnakbar, setShowSnakbar] = useState(false);
    const [snakbarMsg, setSnakbarMsg] = useState("");
    const [msgType, setMsgType] = useState("");
    const [stepEventCalled, setStepEventCalled] = useState([]);
    const [msgIcon, setmsgIcon] = useState("");
    const [visibleMobileLoginModal, setVisibleMobileLoginModal] = useState(false);
    const [preventAutoHide, setPreventAutoHide] = useState(false);
    const { tutorialVisible, tutorialStep } = IUserTypeState
    console.log("tutorialVisible", tutorialVisible);
    console.log("tutorialStep", tutorialStep);
    const classes = useStyles()
    const foundStepIndex = TUTORIAL_STEPS.findIndex(it => it.step === tutorialStep)
    const width = useWidth()
    const isMobile = width < 768
    useEffect(() => {
        const showTut = localStorage.getItem("fromUrl") === "true"
        console.log("showTut", showTut);

        if (tutorialVisible && calendar[0] && calendar[0].length && showTut) {
            localStorage.removeItem("fromUrl")
            const todayEl = document.getElementById(moment(calendar[0][0]).format(TRACKING_CONST.DATE_FORMAT))
            if (todayEl && !IUserTypeState?.isExpand) {
                todayEl.scrollIntoView({
                    behavior: 'smooth',
                    block: "end", inline: "end"
                })
            }
            if (todayEl && IUserTypeState?.isExpand) {
                todayEl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'end'
                })
            }
        }
    }, [calendar, tutorialVisible])
    const setStep = (step) => {
        const foundStepIndex = TUTORIAL_STEPS.findIndex(it => it.step === Number(step))
        if (foundStepIndex > -1) {
            if (TUTORIAL_STEPS[foundStepIndex].skip) {
                setStep(Number(step) + 1)
            } else {
                localStorage.setItem("tutorialStep", step)
                userTypeDispatch(setToturialStepGlobal(step))
            }
        } else {
            localStorage.setItem("tutorialStep", step)
            userTypeDispatch(setToturialStepGlobal(step))
        }

    }
    useEffect(() => {
        if (tutorialVisible) {
            // setStep(1)
        }
    }, [tutorialVisible])
    useEffect(() => {
        if (tutorialVisible) {
            if (tutorialStep === 1) {
                setTimeout(() => {
                    setStep(tutorialStep + 1)
                }, 2000);
            }
            if (tutorialStep === 2) {
                setTimeout(() => {
                    setStep(tutorialStep + 1)
                }, 2000);
            }
        }
    }, [tutorialVisible, tutorialStep])
    const onButtonClick = (eventName?: string) => {
        setStep(tutorialStep + 1)
        if (eventName && !stepEventCalled.includes(eventName)) {
            setStepEventCalled((existingValues) => {
                return [...existingValues, eventName]
            })
            trackingService.signupCompletedBoarding(IUserTypeState.token, {
                mixpanel_type: eventName
            });
        }
    }
    const onBackButtonClick = () => {
        setStep(tutorialStep - 1)
    }
    const onSkip = () => {
        setStep(9)
        localStorage.setItem("tutorialStep", "9")
        userTypeDispatch(setToturialStepGlobal(9))
    }
    if (foundStepIndex < 0 || isMobile) {
        return null
    }
    const currentStep = TUTORIAL_STEPS[foundStepIndex]
    currentStep.dialogueStyles = {
        ...currentStep.dialogueStyles,
        "& .MuiDialog-paper": {
            ...currentStep.dialogueStyles["& .MuiDialog-paper"],
            ...(isDarkMode ? {
                backgroundColor: "var(--dark-card-background)",
                backgroundImage: "none !important",
                border: "1px solid var(--dark-border) !important",
            } : {}),
        }
    }
    if (visibleMobileLoginModal) {
        return <MobileLinkModal
            visibleMobileLoginModal={visibleMobileLoginModal}
            setVisibleMobileLoginModal={setVisibleMobileLoginModal}
            isMobile={width < 768}
        />
    }
    if (currentStep.islast) {
        return <>
            <div style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 998,
                backgroundColor: "rgba(0,0,0,0.7)",
                backdropFilter: "blur(1px)",
            }}>
                <ConfettiTNT autoStop={false} />
                <Dialog
                    onClose={() => { }}
                    open={tutorialVisible}
                    className={!isMobile && "dialogWrapper"}
                    disableEscapeKeyDown
                    sx={{
                        ...currentStep.dialogueStyles,
                        zIndex: 10000,
                        "& .MuiBackdrop-root": {
                            backgroundColor: "transparent",
                        }
                    }}
                    PaperProps={{
                        className: isMobile && "hide-scrollbar"
                    }}
                >
                    <ImageContent />
                    {currentStep.content(IUserTypeState, () => {
                        setStep(1)
                        localStorage.setItem("showTutorial", "false")
                        userTypeDispatch(setVisibleTutorialGloabl(false))
                        userTypeDispatch(setToturialStepGlobal(1))
                        setVisibleMobileLoginModal(true)
                        if (TRACKING_EVENT_NAMES.DAY_1_IN_APP_ONBOARDING_FINISHED && !stepEventCalled.includes(TRACKING_EVENT_NAMES.DAY_1_IN_APP_ONBOARDING_FINISHED)) {
                            setStepEventCalled((existingValues) => {
                                return [...existingValues, TRACKING_EVENT_NAMES.DAY_1_IN_APP_ONBOARDING_FINISHED]
                            })
                            trackingService.signupCompletedBoarding(IUserTypeState.token, {
                                mixpanel_type: TRACKING_EVENT_NAMES.DAY_1_IN_APP_ONBOARDING_FINISHED
                            });
                        }
                    }, onBackButtonClick, onSkip, setShowSnakbar,
                        setSnakbarMsg, setMsgType, setPreventAutoHide, setmsgIcon, IUserTypeState.connectedIntegrations && Object.keys(IUserTypeState.connectedIntegrations).length ? Object.keys(IUserTypeState.connectedIntegrations) : [])}
                </Dialog>
            </div>


        </>
    }
    if (currentStep.fromElement) {
        return <CustomElementSpotlight
            isDarkMode={isDarkMode}
            elementSelector={currentStep.elementSelector(IUserTypeState)}
            tooltip={currentStep.content(IUserTypeState, onButtonClick, onBackButtonClick, onSkip)}
            tooltipPlacement={currentStep.tooltipPlacement}
            clickable={currentStep.clickable}
            onButtonClick={onButtonClick}
        />
    }
    if (currentStep.modal) {
        return <>
            <SnackBarCompV2
                showSnakbar={showSnakbar}
                handleCloseSnakbar={() => {
                    if (!preventAutoHide) {
                        setPreventAutoHide(false)
                        setShowSnakbar(false);
                    }
                }}
                preventAutoHide={preventAutoHide}
                snakbarMsg={<CommonTypo size={16} fontWeight={600} lineHeight={19.2} color={msgType === "error" ? "#292B2A" : "var(--color-text-primary)"}>{snakbarMsg}</CommonTypo>}
                type={msgType ? msgType : "success"}
                alertSx={{
                    background: msgType === "info" ? "var(--color-border)" : msgType === "error" ? "#FF5555" : "var(--color-new-main)",
                    boxShadow: "0px 4px 8px 0px #0000001A",
                    padding: "16px",
                    borderRadius: "12px",
                    height: "52px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    "& .MuiAlert-icon": {
                        marginRight: "0px"
                    },
                    marginTop: msgType === "info" ? "84px" : 0
                }}
                icon={msgIcon ? msgIcon : msgType === "success" ? <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.7883 7.46172C13.8757 7.54882 13.945 7.65231 13.9923 7.76626C14.0397 7.88022 14.064 8.00239 14.064 8.12578C14.064 8.24917 14.0397 8.37134 13.9923 8.4853C13.945 8.59925 13.8757 8.70275 13.7883 8.78984L9.41328 13.1648C9.32619 13.2522 9.22269 13.3216 9.10874 13.3689C8.99478 13.4162 8.87261 13.4406 8.74922 13.4406C8.62583 13.4406 8.50366 13.4162 8.3897 13.3689C8.27575 13.3216 8.17226 13.2522 8.08516 13.1648L6.21016 11.2898C6.12295 11.2026 6.05378 11.0991 6.00658 10.9852C5.95939 10.8712 5.9351 10.7491 5.9351 10.6258C5.9351 10.5025 5.95939 10.3803 6.00658 10.2664C6.05378 10.1525 6.12295 10.0489 6.21016 9.96172C6.29737 9.87451 6.40089 9.80534 6.51483 9.75814C6.62877 9.71095 6.75089 9.68666 6.87422 9.68666C6.99755 9.68666 7.11967 9.71095 7.23361 9.75814C7.34755 9.80534 7.45108 9.87451 7.53828 9.96172L8.75 11.1719L12.4617 7.45938C12.5489 7.37236 12.6525 7.3034 12.7664 7.25642C12.8803 7.20944 13.0023 7.18537 13.1255 7.18559C13.2487 7.18581 13.3706 7.21031 13.4844 7.25769C13.5981 7.30507 13.7014 7.3744 13.7883 7.46172ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31038 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10Z" fill="#3E4240" />
                </svg> : <ModalCloseIconBlack color="#000000" />
                }
            />
            <Dialog
                onClose={() => { }}
                open={tutorialVisible}
                className={!isMobile && "dialogWrapper"}
                disableEscapeKeyDown
                sx={{
                    ...currentStep.dialogueStyles,
                    zIndex: 1000
                }}
                PaperProps={{
                    className: isMobile && "hide-scrollbar"
                }}
            >
                {currentStep.content(
                    {...IUserTypeState, isDarkMode}, 
                    onButtonClick, 
                    onBackButtonClick, 
                    onSkip, 
                    setShowSnakbar,
                    setSnakbarMsg, 
                    setMsgType, 
                    setPreventAutoHide, 
                    setmsgIcon, 
                    IUserTypeState.connectedIntegrations && Object.keys(IUserTypeState.connectedIntegrations).length ? Object.keys(IUserTypeState.connectedIntegrations) : [],
                )}
                {currentStep.brearVisible && <Box position={"fixed"} bottom={-5} left={"60px"} zIndex={0}>
                    <img src="/tutorialcurebear.png" alt="tutorialcurebear" />
                </Box>}
            </Dialog>
        </>
    }
    if (currentStep.useCustomTooltip) {
        return <CustomTooltip
            targetSelector={currentStep.tooltipTargetSelector(IUserTypeState)}
            content={currentStep.content(IUserTypeState, onButtonClick, onBackButtonClick, onSkip)}
            tooltipPlacement={currentStep.tooltipPlacement}
        // {...currentStep.customTooltipProps}
        />
    }
    if (currentStep.fromTable) {
        return <>
            <TableSpotlightOverlay
                columnSelector={currentStep.columnSelector ? currentStep.columnSelector(IUserTypeState) : null}
                rowSelector={currentStep.rowSelector ? currentStep.rowSelector(IUserTypeState) : null}
                tooltip={currentStep.content(IUserTypeState, onButtonClick, onBackButtonClick, onSkip)}
                tooltipPlacement={currentStep.tooltipPlacement}
                tooltipTargetSelector={currentStep.tooltipTargetSelector ? currentStep.tooltipTargetSelector(IUserTypeState) : null}
                customInTable={TUTORIAL_STEPS[foundStepIndex].customInTable ? TUTORIAL_STEPS[foundStepIndex].customInTable(classes, isDarkMode) : null}
                brearVisible={currentStep.brearVisible || false}
                clickable={currentStep.clickable || false}
                onButtonClick={onButtonClick}
                bearFile={currentStep.bearFile}
                isDarkMode={isDarkMode}
            />

        </>
    }

    return null
}

export default TutorialsFlow